var exports = {
  "section-theme--black": "x43aef4ae--7e86ca--section-theme--black",
  "section-theme--white": "x43aef4ae--7e86ca--section-theme--white",
  "container": "x43aef4ae--7e86ca--container",
  "container--v2-design": "x43aef4ae--7e86ca--container--v2-design",
  "content-offset--24": "x43aef4ae--7e86ca--content-offset--24",
  "title-container": "x43aef4ae--7e86ca--title-container",
  "right-adornment": "x43aef4ae--7e86ca--right-adornment",
  "semi-title": "x43aef4ae--7e86ca--semi-title",
  "description": "x43aef4ae--7e86ca--description",
  "hint-icon": "x43aef4ae--7e86ca--hint-icon",
};

module.exports = exports;
